import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bulkDelete, endBulkDelete } from '../../store/actions/properties';
import BulkDeleteModal from 'components/modals/bulk_delete_modal';

export class PropertiesBulkDeleteModal extends React.Component {
  static propTypes = {
    bulkDelete: PropTypes.bool.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    onBulkDelete: PropTypes.func.isRequired,
    onCancelBulkDelete: PropTypes.func.isRequired
  };

  render() {
    const { bulkDelete, selectedPropertyIds, onCancelBulkDelete, onBulkDelete } = this.props;

    return (
      <BulkDeleteModal
        entityCount={(selectedPropertyIds || []).length}
        entityName="Properties"
        shown={bulkDelete}
        onCancel={onCancelBulkDelete}
        onDelete={onBulkDelete}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkDelete: state.properties.startBulkDelete,
  selectedPropertyIds: state.selectList.selectedPropertyIds
});

const mapDispatchToProps = {
  onBulkDelete: bulkDelete,
  onCancelBulkDelete: endBulkDelete
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesBulkDeleteModal);
